import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})

export class KitchenStockPurchaseService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) { }

   getAll():Observable <any> {
    return this.http.get<any>(`${this.env.apiUrl}/kitchen-stock-purchase`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

    create(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/kitchen-stock-purchase`,  data)
        .pipe(catchError(this.handleError));
       
    }

 
    private handleError(errorResponse: HttpErrorResponse) { 
      return throwError(errorResponse || "Server Error");

      }


}
